// extracted by mini-css-extract-plugin
module.exports = {"LikedSongs":"LikedSongs_LikedSongs__2cceS","PageNavigation":"LikedSongs_PageNavigation__Ov5T6","Prev":"LikedSongs_Prev__gt5MT","Next":"LikedSongs_Next__1lkMh"};